import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useApp } from "./context";
import { t } from "./i18n";

export default function Footer() {
  const { lang } = useApp();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  return (
    <footer style={{ background: "var(--bg-secondary)", borderTop: "1px solid var(--border)" }} data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-display text-3xl">STILET</div>
          <p className="mt-4 max-w-md" style={{ color: 'var(--text-secondary)' }}>
            {t("brand.tagline_" + lang, lang)}
          </p>
        </div>
        <div>
          <div className="overline mb-4">{t("footer.explore", lang)}</div>
          <ul className="space-y-2">
            <li><Link to="/apartments" className="nav-link" data-testid="footer-apartments">{t("nav.apartments", lang)}</Link></li>
            <li><Link to="/services" className="nav-link" data-testid="footer-services">{t("nav.services", lang)}</Link></li>
            <li><Link to="/about" className="nav-link" data-testid="footer-about">{t("nav.about", lang)}</Link></li>
            <li><Link to="/faq" className="nav-link" data-testid="footer-faq">{t("nav.faq", lang)}</Link></li>
            <li><Link to="/contact" className="nav-link" data-testid="footer-contact">{t("nav.contact", lang)}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm" style={{ color: 'var(--text-secondary)' }}>
            <li>{t("contact.address", lang)}</li>
            <li>hello@stiletresidence.com</li>
            <li>
              <a href="https://wa.me/38269409419?text=Hello!%20I'm%20interested%20in%20Stilet%20Residence." target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" style={{ borderBottom: '1px solid currentColor' }}>
                WhatsApp · +382 69 409 419
              </a>
            </li>
            <li className="pt-3"><Link to="/admin" className="overline" data-testid="footer-admin-link">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="container-x py-6 flex flex-col md:flex-row justify-between gap-3 text-xs" style={{ borderTop: "1px solid var(--border)", color: 'var(--text-muted)' }}>
        <span>© {new Date().getFullYear()} Stilet Residence. {t("footer.rights", lang)}</span>
        <span>Kotor · Montenegro</span>
      </div>
    </footer>
  );
}
